import { InboxNotiResponseDto } from '@diritto/common/notification/dtos/inbox-noti.response.dto';
import { NotiApi } from 'api/ApiHelper';
import { notiQueryKey } from 'queries/noti/queryKey';
import { useInfiniteQuery } from '@tanstack/react-query';
import { InboxNotiType } from '@diritto/common/notification/constants';

export const INBOX_NOTI_LIST_PAGE_ITEM_COUNT = 20;

const getNextPageParam = (lastGroup: InboxNotiResponseDto, allGroups: InboxNotiResponseDto[]) => {
  if (lastGroup.inboxNotifications.length < INBOX_NOTI_LIST_PAGE_ITEM_COUNT) {
    return undefined;
  }
  return allGroups.reduce((acc, current) => acc + current.inboxNotifications.length, 0);
};

export const useGetInboxNotificationsInfiniteQuery = (inboxNotiType: InboxNotiType) =>
  useInfiniteQuery<InboxNotiResponseDto>({
    queryKey: notiQueryKey.inboxNotiList(inboxNotiType),
    queryFn: ({ pageParam = 0 }) =>
      NotiApi.findInboxNotificationsByInboxNotiType(inboxNotiType, {
        offset: pageParam as number,
        limit: INBOX_NOTI_LIST_PAGE_ITEM_COUNT,
      }),
    initialPageParam: 0,
    getNextPageParam,
  });
